import VueKonva from 'vue-konva'

// vue-konva's node components (v-group, v-rect, v-text, etc.) don't render real DOM
// elements and don't declare Vue `emits`, so passing drag/pointer listeners to them
// (the officially documented way to do drag & drop with vue-konva, see
// https://konvajs.org/docs/vue/Drag_And_Drop.html) always triggers Vue's "extraneous
// non-emits event listeners" warning. It's harmless noise, not a bug, so filter out
// just this specific message instead of leaving the console flooded on every drag.
const EXTRANEOUS_LISTENER_WARNING = /Extraneous non-emits event listeners \(([^)]*)\) were passed to component but could not be automatically inherited because component renders fragment or text root nodes/
const KNOWN_KONVA_EVENT_NAMES = new Set([
	'click', 'dblclick', 'mousedown', 'mouseup', 'mouseover', 'mouseout', 'mousemove',
	'touchstart', 'touchmove', 'touchend', 'tap', 'dbltap',
	'dragstart', 'dragmove', 'dragend', 'wheel'
])

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.use(VueKonva)

	const previousWarnHandler = nuxtApp.vueApp.config.warnHandler
	nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
		const match = msg.match(EXTRANEOUS_LISTENER_WARNING)
		const listenerNames = match?.[1]?.split(',').map((name) => name.trim()) ?? []
		if (listenerNames.length > 0 && listenerNames.every((name) => KNOWN_KONVA_EVENT_NAMES.has(name))) {
			return
		}

		if (previousWarnHandler) {
			previousWarnHandler(msg, instance, trace)
		} else {
			console.warn(`[Vue warn]: ${msg}${trace}`)
		}
	}
})
